import { Component } from '@angular/core';
import { GlobalConstants } from 'src/app/common/global';
import { environment } from 'src/environments/environment';
import { Services } from "src/app/services/api.service";
import { Router } from '@angular/router';
import { ProfileService } from 'src/app/services/profile.service';
import { CommonModule } from '@angular/common';
import { MapComponent } from './map/map.component';
import { ModalService } from 'src/app/services/modal.service';
import { ModalNames } from 'src/app/common/modal.config';

@Component({
  selector: 'app-membership',
  templateUrl:  `./${environment.pageFolder}/membership.${environment.pageFolder}.component.html`,
  styleUrls: [`./${environment.pageFolder}/membership.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule, MapComponent]
})

export class MembershipComponent {
  membershipCards: any = [
    {
      title: "Moja članstva",
      image: "player.png",
      buttonText: "Pogledajte aktivno članstvo",
      buttonUrl: "/membership-profile",
      linkText: "Pogledajte članstvo obitelji",
      linkUrl: "/membership-profile-others",
      id: 1
    },
    {
      title: "Postanite član",
      image: "teams.png",
      buttonText: "Učlanite sebe",
      buttonUrl: "/buy-membership?type=full-fledged&holder=own",
      linkText: "Učlanite člana obitelji",
      linkUrl: "/buy-membership?type=full-fledged&holder=others",
      id: 2
    },
    {
      title: "Povežite članstvo",
      image: "member.png",
      buttonText: "POVEŽITE SVOJE ČLANSTVO",
      buttonUrl: "/membership-profile",
      linkText: "Povežite članstvo svoje obitelji",
      linkUrl: "/membership-profile-others",
      id: 3
    },
    {
      title: "Produljite članstvo",
      image: "connect-cards.png",
      buttonText: "PRODULJITE SVOJE ČLANSTVO",
      buttonUrl: "/membership-profile",
      linkText: "Produljite članstvo svoje obitelji",
      linkUrl: "/membership-profile-others",
      id: 4
    },
    {
      title: "Prijatelj kluba",
      image: "plavi-prijatelj-ikona.svg",
      buttonText: "POSTANI PRIJATELJ KLUBA",
      buttonUrl: "/buy-membership?type=club-friend",
      linkText: "Pogledajte prijateljstva kluba",
      linkUrl: "/club-friends-profile",
      id: 5
    }
  ]
  isLogged:boolean = GlobalConstants.isAuth;
  loader = document.getElementById("loader-container");
  showMembershipCards: boolean = false;

  constructor(
    public service: Services,
    private router: Router,
    private profileService: ProfileService,
    private readonly modalService: ModalService
  ) {
  }

  ngOnInit() {
    if(!this.isLogged) {
      this.membershipCards = this.membershipCards.filter((card: any) => {
        return card.id !== 1 && card.id !== 3 && card.id !== 4;
      });
      this.showMembershipCards = true;
    } else {
      this.getMemberships();
    }
  }

  ngAfterViewInit():void {
    const openPage = sessionStorage.getItem("openPage");

    setTimeout(() => {
      if(this.isLogged && this.isLogged !== undefined && openPage) {
        openPage && (document.location = environment.redirectUrl + openPage);
      }
    }, 100);
  }

  changeUrl(url: string, id: number) {
    if(!this.isLogged && id !== 2 && id !== 5) {
      this.modalService.openModal(ModalNames.Login);
      sessionStorage.setItem("openPage", url);
    } else {
      const [path, queryString] = url.split('?');
      const queryParams = new URLSearchParams(queryString);
      const type = queryParams.get('type');
      const holderParam = queryParams.get('holder');

      sessionStorage.setItem("membershipHolder", holderParam || '');
      this.router.navigate([path], { queryParams: { type } });
    }
  }
  
  getMemberships() {
    this.toggleLoader(true);
  
    this.profileService.getMemberships(true).subscribe({
      next: (data: any) => {
        const memberships = data.data;
        const own = memberships.own;
        const others = memberships.others;
  
        own && this.updateCardsForOwnMembership(own);
  
        const { canRenewOthers, isActiveOthers } = this.evaluateFamilyMemberships(others || []);

        if(!own && !isActiveOthers) {
          this.removeCardById(1);
        }
  
        if (!canRenewOthers && !own?.isRenewable) {
          this.removeCardById(4);
        }
  
        if (!own && !others) {
          this.removeCardsById([1, 4]);
        } else if (!isActiveOthers) {
          const card = this.membershipCards.find((card: any) => card.id === 1);
          if (card) {
            this.membershipCards[0].linkText = "";
          }
        }
  
        this.showMembershipCards = true;
        this.toggleLoader(false);
      },
      error: () => {
        this.toggleLoader(false);
      }
    });
  }
  
  toggleLoader(show: boolean) {
    if (this.loader) {
      this.loader.style.display = show ? "flex" : "none";
    }
  }
  
  updateCardsForOwnMembership(own: any) {
    this.membershipCards.forEach((card: any) => {
      if (card.id === 2) {
        card.buttonText = "Učlanite člana obitelji";
        card.buttonUrl = "/buy-membership?type=full-fledged&holder=others";
        card.linkText = "";        
      }
  
      if (!own.isRenewable && card.id === 4) {
        card.buttonText = "Produljite članstvo obitelji";
        card.buttonUrl = "/membership-profile-others";
        card.linkText = "";
      }
  
      if (card.id === 3) {
        card.buttonText = "Povežite članstvo obitelji";
        card.buttonUrl = "/membership-profile-others";
        card.linkText = "";
      }
    });
  }
  
  setCardForOthersOnly() {
    const card = this.membershipCards[0];
    card.buttonText = "Pogledajte aktivno članstvo";
    card.buttonUrl = "/membership-profile";
    card.linkText = "Pogledajte članstvo obitelji";
  }
  
  evaluateFamilyMemberships(others: any[]) {
    let canRenewOthers = false;
    let isActiveOthers = false;
  
    others
      .filter(item => item.membershipType !== "V4")
      .forEach(item => {
        if (item.isRenewable) canRenewOthers = true;
        if (item.isActive) isActiveOthers = true;
      });
  
    return { canRenewOthers, isActiveOthers };
  }
  
  removeCardById(id: number) {
    this.membershipCards = this.membershipCards.filter((card: any) => card.id !== id);
  }
  
  removeCardsById(ids: number[]) {
    this.membershipCards = this.membershipCards.filter((card: any) => !ids.includes(card.id));
  }
}